import "./App.css";
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import SplashScreen from "./components/SplashScreen";
import LivePurchaseTicker from "./components/LivePurchaseTicker";
import Home from "./pages/Home";
import BrandsPage from "./pages/BrandsPage";
import ProductDetail from "./pages/ProductDetail";
import Checkout from "./pages/Checkout";
import OrderSuccess from "./pages/OrderSuccess";
import MobileTopup from "./pages/MobileTopup";
import ESim from "./pages/ESim";
import Swap from "./pages/Swap";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import AdminHealth from "./pages/AdminHealth";
import AdminPromos from "./pages/AdminPromos";
import AdminTickets from "./pages/AdminTickets";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { CurrencyProvider } from "./context/CurrencyContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Toaster } from "./components/ui/toaster";

function App() {
  const [showSplash, setShowSplash] = useState(() => !sessionStorage.getItem('tokengate_splash_shown'));

  useEffect(() => {
    if (showSplash) sessionStorage.setItem('tokengate_splash_shown', '1');
  }, [showSplash]);

  return (
    <div className="App">
      {showSplash && <SplashScreen onDone={() => setShowSplash(false)} />}
      <ThemeProvider>
        <AuthProvider>
          <CurrencyProvider>
            <CartProvider>
              <BrowserRouter>
                <Header />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/browse" element={<BrandsPage />} />
                  <Route path="/browse/:categoryId" element={<BrandsPage />} />
                  <Route path="/product/:brandId" element={<ProductDetail />} />
                  <Route path="/checkout" element={<Checkout />} />
                  {/* /cart is a legacy/expected URL; the app funnels the cart drawer straight into checkout. */}
                  <Route path="/cart" element={<Navigate to="/checkout" replace />} />
                  <Route path="/order/:orderId" element={<OrderSuccess />} />
                  <Route path="/mobile-topup" element={<MobileTopup />} />
                  <Route path="/esim" element={<ESim />} />
                  <Route path="/swap" element={<Swap />} />
                  <Route path="/account" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/account/*" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard/*" element={<Dashboard />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="/admin/health" element={<AdminHealth />} />
                  <Route path="/admin/promos" element={<AdminPromos />} />
                  <Route path="/admin/tickets" element={<AdminTickets />} />
                  {/* Catch-all: any unknown route lands users on the home page instead of a blank screen. */}
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
                <Footer />
                <LivePurchaseTicker />
                <Toaster />
              </BrowserRouter>
            </CartProvider>
          </CurrencyProvider>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
